(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-sticky-atc"] && !Shopify.designMode) return;
  try {
    class LpStickyAtc extends HTMLElement {
    connectedCallback() {
      this.mainButton = document.querySelector('.product-single__form [data-add-to-cart]');
      this.select = document.querySelector('.product-single__form select[name="id"]');
      this.button = this.querySelector('[data-lp-sticky-button]');
      this.label = this.querySelector('[data-lp-sticky-label]');
      const data = this.querySelector('[data-lp-sticky-variants]');
      this.variants = data ? JSON.parse(data.textContent) : {};
      if (!this.mainButton || !this.button) return;

      this.button.addEventListener('click', () => this.mainButton.click());
      // The size picker updates the hidden select without a change event; the theme
      // announces the new variant on document instead (assets/theme.js _onSelectChange).
      this.onVariantChange = (event) => {
        const variant = event.detail && event.detail.variant;
        if (variant) this.sync(String(variant.id));
      };
      document.addEventListener('variant:change', this.onVariantChange);
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          this.hidden = entry.isIntersecting;
        }
      });
      this.observer.observe(this.mainButton);
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('variant:change', this.onVariantChange);
    }

    sync(id) {
      // Ignore variants of other products (quick view etc.): they aren't in this map.
      const variant = this.variants[id || this.select?.value];
      if (!variant) return;
      // Single-size products have no meaningful variant title ("Default Title"): show the price alone.
      this.label.textContent = variant.title ? `${variant.title} · ${variant.price}` : variant.price;
      this.button.disabled = !variant.available;
    }
  }

  if (!customElements.get('lp-sticky-atc')) {
    customElements.define('lp-sticky-atc', LpStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plant-facts"] && !Shopify.designMode) return;
  try {
    class PlantArea extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.plant-area__form');
      this.input = this.querySelector('.plant-area__input');
      this.result = this.querySelector('.plant-area__result');
      if (!this.form || !this.input || !this.result) return;

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.lookup(this.input.value, false);
      });
      this.result.addEventListener('click', (event) => {
        if (!event.target.closest('.plant-area__change')) return;
        this.result.innerHTML = '';
        this.form.hidden = false;
        // Start empty so a new postcode can be typed straight away (Bart, 2026-10-17); the saved one
        // only changes once a new postcode is looked up.
        this.input.value = '';
        this.input.focus();
      });

      let saved = '';
      try {
        saved = window.localStorage.getItem(PlantArea.KEY) || '';
      } catch (error) {
        saved = '';
      }
      // Nothing typed on this device yet: a logged-in customer's own postcode (their default
      // address, set on window.HC_CUSTOMER in layout/theme.liquid, the same hook the
      // back-in-stock button uses).
      const account = String((window.HC_CUSTOMER && window.HC_CUSTOMER.postcode) || '').trim();
      if (!/^\d{4}$/.test(saved) && /^\d{4}$/.test(account)) saved = account;
      if (/^\d{4}$/.test(saved)) {
        this.input.value = saved;
        this.lookup(saved, true);
      }
    }

    static load(src) {
      if (!PlantArea.data) {
        PlantArea.data = fetch(src).then((response) => {
          if (!response.ok) throw new Error(`Climate data ${response.status}`);
          return response.json();
        });
        PlantArea.data.catch(() => {
          PlantArea.data = null;
        });
      }
      return PlantArea.data;
    }

    // Live plants can't go to these states (quarantine), so there's no planting advice to give.
    static closedState(postcode) {
      const n = parseInt(postcode, 10);
      if (postcode.startsWith('08') || postcode.startsWith('09')) return 'the Northern Territory';
      if (n >= 6000 && n <= 6999) return 'Western Australia';
      if (n >= 7000 && n <= 7999) return 'Tasmania';
      return null;
    }

    static isOn(mask, month) {
      return ((mask >> ((month + 12) % 12)) & 1) === 1;
    }

    // "March to May and September to November"; runs can wrap over the new year.
    static ranges(mask) {
      if (mask === 4095) return 'all year';
      let start = 0;
      while (start < 12 && PlantArea.isOn(mask, start)) start += 1;
      const runs = [];
      for (let i = 1; i <= 12; i += 1) {
        const month = (start + i) % 12;
        if (!PlantArea.isOn(mask, month)) continue;
        if (!PlantArea.isOn(mask, month - 1) || runs.length === 0) runs.push([month, month]);
        runs[runs.length - 1][1] = month;
      }
      runs.sort((x, y) => x[0] - y[0]);
      const names = runs.map(([a, b]) => (a === b ? PlantArea.MONTHS[a] : `${PlantArea.MONTHS[a]} to ${PlantArea.MONTHS[b]}`));
      if (names.length < 2) return names.join('');
      return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
    }

    // "from April to October" for one stretch of months, otherwise "in June and August".
    static during(mask) {
      const text = PlantArea.ranges(mask);
      if (text.indexOf(' and ') === -1 && text.indexOf(' to ') !== -1) return `from ${text}`;
      return `in ${text}`;
    }

    // "April to November", "All year", "Spring to Autumn" -> month mask; anything else -> null.
    static parseMonths(text) {
      const t = String(text || '').toLowerCase();
      if (!t.trim()) return null;
      if (/all\s*(the\s*)?year|year\s*round/.test(t)) return 4095;
      const span = (from, to) => {
        let mask = 0;
        for (let i = from; ; i = (i + 1) % 12) {
          mask |= 1 << i;
          if (i === to) break;
        }
        return mask;
      };
      const names = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
      const m = t.match(/(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\s*(?:to|until|-|\u2013)\s*(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/);
      if (m) return span(names.indexOf(m[1]), names.indexOf(m[2]));
      const seasons = { spring: [8, 10], summer: [11, 1], autumn: [2, 4], winter: [5, 7] };
      const s = t.match(/(spring|summer|autumn|winter)\s*(?:to|until|-|\u2013)\s*(spring|summer|autumn|winter)/);
      if (s) return span(seasons[s[1]][0], seasons[s[2]][1]);
      return null;
    }

    static nextMonth(mask, from) {
      for (let i = 1; i <= 12; i += 1) {
        const month = (from + i) % 12;
        if (PlantArea.isOn(mask, month)) return month;
      }
      return -1;
    }

    remember(postcode) {
      try {
        window.localStorage.setItem(PlantArea.KEY, postcode);
      } catch (error) {
        // Private browsing or blocked storage: the answer still shows, it just isn't kept.
      }
    }

    showError(message) {
      this.form.hidden = false;
      this.result.innerHTML = `<p class="plant-area__error">${message}</p>`;
    }

    showResult(html) {
      this.form.hidden = true;
      this.result.innerHTML = html;
    }

    async lookup(raw, quiet) {
      const postcode = String(raw || '').replace(/\s/g, '');
      if (!/^\d{4}$/.test(postcode)) {
        if (!quiet) this.showError('Enter a 4-digit postcode.');
        return;
      }
      const where = `<p class="plant-area__where"><span><strong>${postcode}</strong></span><button type="button" class="plant-area__change">Change</button></p>`;
      const closed = PlantArea.closedState(postcode);
      if (closed) {
        this.remember(postcode);
        this.showResult(`${where}<div class="plant-area__text"><p>We can't send live plants to ${closed} because of quarantine restrictions, sorry. Our dried herbs and teas can go anywhere in Australia.</p></div>`);
        return;
      }
      let data;
      try {
        data = await PlantArea.load(this.dataset.src);
      } catch (error) {
        if (!quiet) this.showError("Sorry, the planting guide didn't load. Please try again in a moment.");
        return;
      }
      const row = data.p[postcode];
      if (!row) {
        if (!quiet) this.showError(`We couldn't find ${postcode}. Please check the postcode and try again.`);
        return;
      }
      this.remember(postcode);
      this.showResult(this.describe(postcode, row, data));
    }

    describe(postcode, row, data, now = new Date().getMonth()) {
      const [regionIndex, frostNights, frostMask, coldMask, hotMask] = row;
      const regionKey = data.regions[regionIndex];
      // Sandra's answers describe Mudgeeraba. A plant that grows all year here can still struggle in tropical heat
      // (horseradish: "struggling in the tropical heat", review 2022), so plant.tropical_season gives the tropics
      // their own season (Bart, 2026-10-29).
      const season = (regionKey === 'Tropical' && this.dataset.tropicalSeason) || this.dataset.season;
      const frost = this.dataset.frost;
      const combo = data.combos.indexOf(`${season}-${frost}`);
      const plantMask = row[5 + combo];
      const spansClimates = row[5 + data.combos.length] === 1;
      const months = Math.abs(plantMask);
      const nowName = PlantArea.MONTHS[now];
      const region = PlantArea.REGION_NAMES[regionKey] || regionKey.toLowerCase();
      const life = (this.dataset.life || '').toLowerCase();
      const perennial = life !== '' && life.indexOf('annual') === -1;
      // Only annuals and biennials (coriander, parsley) bolt in the heat; cool-season perennials
      // such as horseradish and sweet woodruff just struggle (pilot plants, 2026-10-17).
      const bolts = life.indexOf('annual') !== -1 || life.indexOf('biennial') !== -1;
      // A quick cool-season annual in the tropics: the cooler dry-season months are a real planting
      // time, just a short one, so it isn't "hard going" (checked against Gardenate and Deep Green
      // Permaculture, 2026-10-18). Cool-climate perennials there stay "hard going".
      const quickCrop = plantMask < 0 && season === 'cool' && bolts;
      const struggle = plantMask < 0 && !quickCrop;
      const frostRisk = frostNights >= 1 && frostMask !== 0;
      const next = PlantArea.nextMonth(months, now);
      const nextName = next >= 0 ? PlantArea.MONTHS[next] : '';
      const plantNow = PlantArea.isOn(months, now);
      const lines = [];

      // Will it grow here?
      let verdict = 'Grows well in your area';
      let verdictClass = 'is-good';
      let verdictNote = '';
      if (struggle) {
        verdict = 'Hard going in your area';
        verdictClass = 'is-hard';
        verdictNote = {
          cool: `${bolts ? 'It runs to seed quickly in your heat.' : 'It struggles in your heat.'} Give it afternoon shade and keep it moist.`,
          warm: 'It needs more warmth than your summers usually give. Grow it in a pot in your warmest, sunniest spot.',
          all: 'It finds your climate hard going.'
        }[season];
      } else if (quickCrop) {
        verdict = 'Grows here with a little help';
        verdictClass = 'is-help';
        verdictNote = 'It runs to seed quickly in your heat, so plant it in your cooler months and keep it moist.';
      } else if (perennial && frost === 'tender' && frostRisk) {
        verdict = 'Grows here with a little help';
        verdictClass = 'is-help';
        verdictNote = 'Frost kills it, so give it a sheltered spot or a pot you can move under cover for winter.';
      } else if (perennial && frost === 'light' && frostNights >= 30) {
        verdict = 'Grows here with a little help';
        verdictClass = 'is-help';
        verdictNote = 'It handles light frosts, but protect it from hard frosts, especially while it\'s young.';
      } else if (perennial && season === 'warm' && frost !== 'hardy' && coldMask !== 0) {
        // Frost-hardy warm growers (passionflower) just die back for winter: no "sulks" tip.
        verdict = 'Grows here with a little help';
        verdictClass = 'is-help';
        verdictNote = 'It sulks through your cool winters, so give it your warmest, most sheltered spot.';
      }

      // When to plant
      if (months === 4095 && !struggle) {
        lines.push('Plant out: <strong>any time of year</strong>.');
      } else {
        lines.push(`${struggle ? 'Best chance' : 'Plant out'}: <strong>${PlantArea.ranges(months)}</strong>.`);
      }

      // What to do this month
      if (!(months === 4095 && !struggle) && nextName) {
        const hot = PlantArea.isOn(hotMask, now);
        const cold = PlantArea.isOn(coldMask, now) || PlantArea.isOn(frostMask, now);
        const keep = frost === 'tender' ? 'somewhere bright and frost-free' : 'somewhere bright and sheltered';
        if (plantNow) {
          lines.push(struggle ? `It's ${nowName}, one of your better months for it.` : `It's ${nowName}, a good time to plant it.`);
        } else if (hot && struggle) {
          lines.push(`It's ${nowName}, one of your hottest months. Your best chance is from ${nextName}.`);
        } else if (season === 'cool' && !cold) {
          lines.push(`It's ${nowName}: ${hot ? 'too hot here for it right now' : 'it\'s warm here'}, and ${bolts ? 'it runs to seed quickly in warm weather' : 'it grows best in cool weather'}. Best planted from ${nextName}. If you plant it now, give it afternoon shade and keep it moist.`);
        } else if (hot) {
          lines.push(`It's ${nowName}, the hottest part of your year. Young plants settle in better from ${nextName}, so keep it potted in part shade until then.`);
        } else if (cold) {
          lines.push(`It's ${nowName}: too cold to plant it out here. Pot it up and keep it ${keep} until ${nextName}.`);
        } else if (season === 'warm') {
          lines.push(`It's ${nowName}: still a bit cool for it here. Best planted out from ${nextName}; until then keep it potted in your warmest, sunniest spot.`);
        } else {
          lines.push(`Best planted out from ${nextName}.`);
        }
      }

      // When to order: only when it adds something to the planting months above
      const inStock = this.dataset.inStock === 'true';
      const availableText = (this.dataset.available || '').trim();
      const available = PlantArea.parseMonths(availableText);
      if (inStock && plantNow) {
        lines.push(struggle ? 'If you\'d like to try it, now\'s your best chance, and it\'s in stock.' : 'It\'s in stock and it\'s planting time for you, so now\'s a good time to order.');
      } else if (!inStock) {
        lines.push('It\'s sold out right now: tap "Email me when it\'s back" and we\'ll let you know.');
      } else if (available !== null) {
        const overlap = available & months;
        if (!overlap && nextName) {
          lines.push(`We usually have it ${available === 4095 ? 'all year' : availableText}, outside your planting time. Order then and keep it potted somewhere sheltered until ${nextName}.`);
        } else if (overlap && overlap !== months) {
          lines.push(`Best time to order for your area: <strong>${PlantArea.ranges(overlap)}</strong>, when we usually have it and it's planting time for you.`);
        }
      }

      // Frost
      if (frostNights < 1 || frostMask === 0) {
        lines.push('Frost is rare here.');
      } else if (frostMask === 4095) {
        lines.push(`Frosts are possible in any month, about ${frostNights} nights a year.`);
      } else if (frostNights <= 10) {
        lines.push(`Light frosts are possible ${PlantArea.during(frostMask)}.`);
      } else {
        lines.push(`Frosts most years ${PlantArea.during(frostMask)}, about ${frostNights} nights a year.`);
      }
      if (life.indexOf('herbaceous') !== -1 && coldMask !== 0) {
        lines.push('It dies back over your winter and regrows in spring.');
      }

      // Their own spot: hills and frost pockets run colder than the postcode average
      const springStart = months !== 4095 && regionKey !== 'Tropical' && (season === 'warm' || frost === 'tender');
      const later = springStart ? ' Plant it a few weeks later in spring.' : '';
      let ask = 'Up in the hills or in a frost pocket?';
      let colder = frostRisk ? 'expect frosts to arrive earlier and finish later' : 'your garden runs colder than this and can get the odd frost';
      if (regionKey === 'Tropical') {
        ask = 'Up in the hills?';
        colder = 'your garden will run a little cooler than this';
      }
      const spot = spansClimates
        ? `Parts of ${postcode} sit higher and run colder. If you're up there${regionKey === 'Tropical' ? '' : ' or in a frost pocket'}, ${colder}.${later}`
        : `${ask} ${colder.charAt(0).toUpperCase()}${colder.slice(1)}.${later}`;

      const strip = PlantArea.MONTHS.map((name, month) => {
        const classes = ['plant-area__month'];
        if (PlantArea.isOn(months, month)) classes.push(struggle ? 'is-best' : 'is-plant');
        if (PlantArea.isOn(frostMask, month)) classes.push('is-frost');
        if (month === now) classes.push('is-now');
        return `<span class="${classes.join(' ')}" title="${name}">${name.charAt(0)}</span>`;
      }).join('');

      const legend = [
        `<span><i class="plant-area__key ${struggle ? 'is-best' : 'is-plant'}"></i>${struggle ? 'Best chance' : 'Plant out'}</span>`,
        frostMask !== 0 ? '<span><i class="plant-area__key is-frost"></i>Frost likely</span>' : '',
        '<span><i class="plant-area__key is-now"></i>Now</span>'
      ].join('');

      return `<p class="plant-area__where"><span><strong>${postcode}</strong>, ${region} climate</span><button type="button" class="plant-area__change">Change</button></p>
        <p class="plant-area__verdict ${verdictClass}">${verdict}</p>
        ${verdictNote ? `<p class="plant-area__verdict-note">${verdictNote}</p>` : ''}
        <div class="plant-area__months" aria-hidden="true">${strip}</div>
        <p class="plant-area__legend" aria-hidden="true">${legend}</p>
        <div class="plant-area__text">${lines.map((line) => `<p>${line}</p>`).join('')}</div>
        <p class="plant-area__spot">${spot}</p>`;
    }
  }

  PlantArea.KEY = 'hc-postcode';
  PlantArea.data = null;
  PlantArea.MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  PlantArea.REGION_NAMES = { Tropical: 'tropical', Subtropical: 'subtropical', Warm: 'warm', Hot: 'hot inland', Cool: 'cool', Alpine: 'alpine' };

  if (!customElements.get('plant-area')) {
    customElements.define('plant-area', PlantArea);
  }

  class PlantCover extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.plant-area__form');
      this.inputs = [...this.querySelectorAll('.plant-cover__input')];
      this.result = this.querySelector('.plant-cover__result');
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.work();
      });
      const toggle = this.closest('details');
      if (toggle) {
        toggle.addEventListener('toggle', () => {
          if (toggle.open) this.inputs[0].focus();
        });
      }
      this.result.addEventListener('click', (event) => {
        const button = event.target.closest('[data-qty]');
        if (button) this.use(parseInt(button.dataset.qty, 10));
      });
    }

    // "4", "4.5", "4,5" or "4.5m" -> 4.5 (metres); anything else -> null
    static metres(value) {
      const n = parseFloat(String(value).replace(',', '.').replace(/[^0-9.]/g, ''));
      return Number.isFinite(n) && n > 0 ? n : null;
    }

    // Area / spacing², the rule extension charts use; a strip narrower than the spacing is one row.
    static count(length, width, cm) {
      const gap = cm / 100;
      if (Math.min(length, width) < gap) return Math.max(1, Math.ceil(Math.max(length, width) / gap));
      return Math.max(1, Math.ceil((length * width) / (gap * gap)));
    }

    static money(cents) {
      return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
    }

    static number(n) {
      return n.toLocaleString('en-AU', { maximumFractionDigits: 2 });
    }

    work() {
      const [length, width] = this.inputs.map((input) => PlantCover.metres(input.value));
      if (!length || !width || length > 200 || width > 200) {
        this.result.innerHTML = '<p class="plant-area__error">Enter the length and width in metres, for example 4 and 3.</p>';
        return;
      }
      const area = Math.round(length * width * 100) / 100;
      const spacing = parseInt(this.dataset.spacing, 10);
      const fast = parseInt(this.dataset.fast, 10);
      const price = parseInt(this.dataset.price, 10) || 0;
      const inStock = this.dataset.inStock === 'true';
      const stock = this.dataset.stock === '' ? null : parseInt(this.dataset.stock, 10);
      const max = parseInt(this.dataset.max, 10) || null;
      const limit = [stock, max].filter((n) => Number.isFinite(n) && n > 0).reduce((a, b) => Math.min(a, b), Infinity);

      const options = [{ kind: 'Standard', cm: spacing }];
      if (fast && fast < spacing) options.push({ kind: 'Faster cover', cm: fast });

      const counts = options.map((option) => PlantCover.count(length, width, option.cm));
      const short = inStock && Number.isFinite(limit) && counts.some((qty) => qty > limit);
      const cards = options.map((option, i) => {
        const qty = counts[i];
        const button = inStock && qty <= limit
          ? `<button type="button" class="btn btn--secondary btn--small plant-cover__use" data-qty="${qty}" aria-label="Set the quantity to ${qty}">Use ${qty}</button>`
          : '';
        return `<div class="plant-cover__option">
          <p class="plant-cover__kind">${option.kind}</p>
          <p class="plant-cover__count">${qty} ${qty === 1 ? 'plant' : 'plants'}</p>
          <p class="plant-cover__detail">${option.cm}cm apart${price ? `, ${PlantCover.money(qty * price)}` : ''}</p>
          ${button}
        </div>`;
      }).join('');

      const notes = [];
      if (options.length > 1) {
        notes.push('Planting closer costs more, but it fills in sooner and leaves less room for weeds.');
      }
      notes.push('Stagger the rows so each plant sits opposite a gap in the row before.');
      let limitNote = '';
      if (!inStock) {
        limitNote = '<p class="plant-cover__tip">It\'s sold out right now: tap "Email me when it\'s back" and we\'ll let you know.</p>';
      } else if (short) {
        const why = stock !== null && limit === stock
          ? `We have ${limit} ready to send right now. Plant those and fill the gaps as more come up.`
          : `You can order up to ${limit} at a time.`;
        limitNote = `<div class="plant-cover__limit"><p class="plant-cover__tip">${why}</p>
          <button type="button" class="btn btn--secondary btn--small plant-cover__use" data-qty="${limit}" aria-label="Set the quantity to ${limit}">Use all ${limit}</button></div>`;
      }

      this.result.innerHTML = `<p class="plant-cover__area">For ${PlantCover.number(length)} &times; ${PlantCover.number(width)}m (${PlantCover.number(area)}m&sup2;)</p>
        <div class="plant-cover__options">${cards}</div>
        ${limitNote}
        ${notes.map((note) => `<p class="plant-cover__tip">${note}</p>`).join('')}`;
    }

    use(qty) {
      const input = document.querySelector('.js-qty__num[name="quantity"]');
      if (!input || !qty) return;
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      const box = input.closest('.js-qty__wrapper') || input;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      box.classList.add('plant-cover__flash');
      setTimeout(() => box.classList.remove('plant-cover__flash'), 1800);
      let done = this.result.querySelector('.plant-cover__done');
      if (!done) {
        done = document.createElement('p');
        done.className = 'plant-cover__done';
        this.result.appendChild(done);
      }
      done.textContent = `Quantity set to ${qty}. Tap Add to cart when you're ready.`;
    }
  }

  if (!customElements.get('plant-cover')) {
    customElements.define('plant-cover', PlantCover);
  }
  } catch(e) { console.error(e); }
})();

})();
